import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const MultiDigitalRetailOfferTypeThankYouViewAsync = lazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "multi-digital-retail-offer-type-thank-you-view" */ './multi-digital-retail-offer-type-thank-you-view'
    ),
  componentName: 'MultiDigitalRetailOfferTypeThankYouView',
});
